import { render } from "./conciergeIcon.vue?vue&type=template&id=705be466&scoped=true"
const script = {}

import "./conciergeIcon.vue?vue&type=style&index=0&id=705be466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705be466"]])

export default __exports__